import React from 'react'
import AddNewCourseForm from '../../../components/AddCoursesStepForm/AddCoursesStepForm'
export default function AdminAddCourses() {
  return (
    <AddNewCourseForm />
  )
}
